export default {
    acquiring_device: "Устройство приема платежей",
    add_expense: "Добавить расходы",
    add_income: "Добавить доход",
    advance_noun: "Аванс",
    all_pay_methods: "Все способы оплаты",
    bank_terminal: "Банковский терминал",
    cash_operation: "Кассовая операция",
    cashdesk: "Касса",
    cashier: "Кассир",
    cashier_inn: "ИНН кассира",
    cashier_name: "Имя кассира",
    cashless_payment: "Безналичная оплата",
    cashless_payments: "Безналичные оплаты",
    cheque: "Чек",
    cheque_generation_in_process_status_might_change_later: "Генерация чека в процессе. Изменение статуса может занять некоторое время.",
    cheques: "Чеки",
    close_shift: "Закрыть смену",
    closing_balance: "Остаток на конец дня",
    create_cheque: "Сформировать фискальный чек",
    dashboard: "Панель управления",
    data_is_invalid: "Данные невалидны",
    data_is_valid: "Данные валидны",
    deposit_to_cashdesk: "Внести в кассу",
    enter_amount: "Введите сумму",
    enter_the_cheque_number: "Введите номер чека",
    error_printing_cheque: "Ошибка печати чека",
    fiscal_cheque_copy_print: "Печать копии фискального чека",
    fiscal_cheque_print: "Печать фискального чека",
    fiscal_device: "Устройство ККТ",
    fiscal_registrar: "Фискальный регистратор",
    fiscal_registrar_management: "Управление фискальным регистратором",
    fixed: "Фиксированный",
    injection: "Пополнение",
    issue_an_advance: "Выдать аванс",
    kkm_url: "HTTP адрес сервера торгового оборудования. Заполнять в случае, если ккм сервер подключен нелокально.",
    market_as_fiscal_cheque_manually: "Отметить как фискальный чек вручную",
    name_of_service_in_cheque: "Название услуги в чеке",
    not_subject_to_vat: "Не облагается НДС",
    only_for_payment_through_terminal: "Только для оплаты через терминал",
    open_shift: "Открыть смену",
    opened_at: "Дата открытия",
    opening_balance: "Остаток на начало дня",
    partial_prepayment: "Частичная предоплата",
    print_totals: "Печать итогов",
    process_advances_as: "Чеки предоплаты проводить как",
    sale_of_goods: "Продажа товаров",
    sales: "Продажи",
    send_services_in_cheque: "Передавать услуги в чеке",
    shift: "Смена",
    shift_number: "Номер смены",
    shifts: "Смены",
    system_to_use: "Использовать систему",
    terminal: "Терминал",
    totals: "Итоги",
    vat_rate: "Ставка НДС",
    waiting_for_payment_in_terminal: "Ожидаем оплату на терминале",
    who_accepts_payment: "Кто принимает оплату",
    withdraw_from_cashdesk: "Изъять из кассы",
    withdrawal: "Изъятие",
    withdrawal_replenishment_from_the_cash_register: "Изъятие / пополнение с кассы",
    withdrawal_replenishment_of_cash: "Изъятие / пополнение наличных денег",
    xreport: "X-отчет",
    xreports: "X-отчеты"
}
